import { webKnots } from '../../../common/back/lace/webKnots'
import { jointOfCatchFace, jointOfIndexFinger, jointOfThumbFinger2 } from './parts/earJointParts'
import { topSidePartOfWebForPicher } from './parts/sideParts'

export const wt4Web = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  // web先端の革パーツ
  topSidePartOfWebForPicher(ctx, webColor, laceColor, stitchColor)
  // ウェブ-人差し指のジョイントパーツ
  jointOfIndexFinger(ctx, webColor, laceColor, 3, 30)
  jointOfIndexFinger(ctx, webColor, laceColor, -24, 90)
  jointOfIndexFinger(ctx, webColor, laceColor, -45, 160)
  jointOfCatchFace(ctx, webColor, laceColor, -10, 12)
  jointOfCatchFace(ctx, webColor, laceColor, 38, 57)
  jointOfThumbFinger2(ctx, webColor, laceColor, 53, -56)
  jointOfThumbFinger2(ctx, webColor, laceColor, 19, -30)
  jointOfThumbFinger2(ctx, webColor, laceColor, -18, -5)
  // web本体のflatパーツ
  ctx.fillStyle = webColor
  ctx.beginPath()
  ctx.moveTo(549, 81) // 左上
  ctx.quadraticCurveTo(502, 166, 482, 247) // 左下1
  ctx.quadraticCurveTo(480, 256, 486, 268) // 左下2
  ctx.quadraticCurveTo(516, 326, 565, 357) // 右下1
  ctx.quadraticCurveTo(571, 362, 582, 362) // 右下2
  ctx.quadraticCurveTo(637, 324, 693, 280) // 右上
  ctx.quadraticCurveTo(660, 140, 549, 81) // 左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  designOfWeb(ctx, stitchColor, 0, 0)
  designOfWeb(ctx, stitchColor, 50, -15)
  designOfWeb(ctx, stitchColor, 100, -30)
  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // 外側
  ctx.moveTo(552, 87) // 左上
  ctx.quadraticCurveTo(508, 166, 486, 252) // 左下
  ctx.quadraticCurveTo(505, 318, 581, 358) // 右下
  ctx.quadraticCurveTo(630, 326, 689, 277) //
  // 内側
  ctx.moveTo(555, 87) // 左上
  ctx.quadraticCurveTo(511, 166, 489, 252) // 左下
  ctx.quadraticCurveTo(505, 313, 581, 355) // 右下
  ctx.quadraticCurveTo(624, 326, 687, 274) //
  ctx.quadraticCurveTo(660, 155, 555, 87) //
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで
  webKnots(ctx, laceColor, -110, 110, 1) // ウェブ先端寄りのウェブ結び目
  allowLace(ctx, laceColor, 8, 8, 0)
  allowLace(ctx, laceColor, 93, -170, 15)
  allowLace(ctx, laceColor, 130, -360, 30)
  webKnots(ctx, laceColor, 10, 80, 0)

  allowLace(ctx, laceColor, 40, -185, 0)
  allowLace(ctx, laceColor, 35, -325, 15)
  allowLace(ctx, laceColor, -5, -450, 30)
  webKnots(ctx, laceColor, -162, 200, -30)
}

const designOfWeb = (ctx: CanvasRenderingContext2D, stitchColor: string, x: number, y: number) => {
  ctx.beginPath()
  ctx.moveTo(505 + x, 215 + y)
  ctx.quadraticCurveTo(535 + x, 295 + y, 535 + x, 295 + y) // 右下
  ctx.quadraticCurveTo(545 + x, 228 + y, 545 + x, 228 + y) // 右上
  ctx.quadraticCurveTo(533 + x, 247 + y, 533 + x, 247 + y) //
  ctx.quadraticCurveTo(505 + x, 215 + y, 505 + x, 215 + y) //
  ctx.stroke()
  ctx.closePath()
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // 外側
  ctx.moveTo(498 + x, 207 + y) // 左上
  ctx.quadraticCurveTo(534 + x, 304 + y, 536 + x, 306 + y) // 右下
  ctx.quadraticCurveTo(550 + x, 218 + y, 550 + x, 218 + y) // 右上
  ctx.quadraticCurveTo(533 + x, 240 + y, 533 + x, 240 + y) //
  ctx.quadraticCurveTo(500 + x, 207 + y, 500 + x, 207 + y) //
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = '#282828'
  ctx.closePath()
}

const allowLace = (ctx: CanvasRenderingContext2D, laceColor: string, x: number, y: number, numerator: number) => {
  ctx.fillStyle = laceColor
  ctx.strokeStyle = '#282828'
  ctx.save()
  ctx.rotate((numerator * Math.PI) / 180)
  // 右側
  ctx.beginPath()
  ctx.moveTo(550 + x, 305 + y) // 左上
  ctx.quadraticCurveTo(549 + x, 335 + y, 549 + x, 335 + y) // 左下1
  ctx.quadraticCurveTo(554 + x, 340 + y, 560 + x, 335 + y) // 右下1
  ctx.quadraticCurveTo(560 + x, 316 + y, 561 + x, 306 + y) // 右上
  ctx.quadraticCurveTo(550 + x, 305 + y, 550 + x, 305 + y) // 左上
  ctx.fill()
  ctx.moveTo(561 + x, 306 + y) // 左上
  ctx.quadraticCurveTo(556 + x, 316 + y, 560 + x, 335 + y) // 右下1
  ctx.stroke()
  ctx.closePath()

  ctx.beginPath()
  ctx.moveTo(532 + x, 303 + y) // 左上
  ctx.quadraticCurveTo(527 + x, 313 + y, 527 + x, 313 + y) // 左下1
  ctx.quadraticCurveTo(549 + x, 314 + y, 549 + x, 314 + y) // 右下1
  ctx.quadraticCurveTo(550 + x, 306 + y, 550 + x, 306 + y) // 右上
  ctx.quadraticCurveTo(543 + x, 302 + y, 532 + x, 303 + y) // 左上
  ctx.moveTo(528 + x, 312 + y) // 左上
  ctx.quadraticCurveTo(535 + x, 310 + y, 549 + x, 314 + y) // 右下1
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  ctx.restore()
}
